import React from "react";
import { useTranslation } from "next-i18next";

import SupportBoardList from "@sellernote/shipda-kr/src/containers/SupportBoardList";

import { getServerSidePropsWithI18n } from "../../../../utils/i18n";

export const getServerSideProps = getServerSidePropsWithI18n();

export default function Use() {
  const { t } = useTranslation(["support-new"]);

  return (
    <SupportBoardList
      title={t("support-new:공통_이용방법")}
      articleType={"howto"}
    />
  );
}
